import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputLabel from "@material-ui/core/InputLabel";
import "../../assets/css/stylesPage.css";

import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import Card from "react-credit-cards";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(styles);

import "react-credit-cards/es/styles-compiled.css";
import CardData from "./CardData";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function CreditCard(props) {
  const classes = useStyles();
  const {
    isOpen,
    onClose,
    inputHandler,
    callBackCard,
    handlerSaveCard,
    cardData,
    saveCard,
  } = props;

  if (!isOpen) {
    return null;
  }

  const monthCard =
    typeof cardData["month-card"] === "undefined"
      ? ""
      : parseInt(cardData["month-card"]);
  const yearCard =
    typeof cardData["month-card"] === "undefined" ? "" : cardData["year-card"];

  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal,
      }}
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
    >
      <DialogTitle
        id="classic-modal-slide-title"
        disableTypography
        className={classes.modalHeader}
      >
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={onClose}
        >
          <Close className={classes.modalClose} />
        </Button>
      </DialogTitle>
      <DialogContent id="modalCreditCard" className={classes.modalBody}>
        <CardData
          inputHandler={inputHandler}
          callBackCard={callBackCard}
          cardData={cardData}
          saveCard={saveCard}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button onClick={handlerSaveCard} color="success">
          Save
        </Button>
        <Button onClick={onClose} color="danger">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
